import React, { useState, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spin } from 'antd'
import { useAuth } from '../hooks/AuthContext'

const AdminPrivateRoute = ({ children }) => {
  const { checkAdminStatus } = useAuth()
  const [gate, setGate] = useState('loading') // loading | ok | guest | staff
  const location = useLocation()

  useEffect(() => {
    let cancelled = false
    const verify = async () => {
      const result = await checkAdminStatus()
      if (cancelled) return
      if (!result.success) {
        setGate('guest')
        return
      }
      if (result.platformAdminTier === 'staff') {
        setGate('staff')
        return
      }
      setGate('ok')
    }
    verify()
    return () => {
      cancelled = true
    }
  }, [checkAdminStatus])

  if (gate === 'loading') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <Spin size='large' />
      </div>
    )
  }

  if (gate === 'guest') {
    return <Navigate to='/admin/login' state={{ from: location }} replace />
  }

  if (gate === 'staff') {
    return <Navigate to='/register' replace />
  }

  return children
}

export default AdminPrivateRoute
